import { Tooltip } from "@mui/material";
import React from "react";
import Description from "@mui/icons-material/Description";
import PublicIcon from "@mui/icons-material/Public";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import CssIcon from "@mui/icons-material/Css";
import ImageIcon from "@mui/icons-material/Image";
import Code from "@mui/icons-material/Code";
import Share from "@mui/icons-material/Share";
import { AccountTreeRounded } from "@mui/icons-material";
import { t } from "i18next";

const TypeCell = ({ asset }) => {
	const getDocumentIcon = type => {
		const iconProps = { sx: { fontSize: 16 }, color: "secondary" };
		switch (type) {
			case "theme":
				return <AccountTreeRounded {...iconProps} />;
			case "documents":
				return <Description {...iconProps} />;
			case "WebPage":
				return <PublicIcon {...iconProps} />;
			case "sitemap":
				return <Share {...iconProps} />;
			case "htmlText":
				return <Code {...iconProps} />;
			case "videos":
				return <OndemandVideoIcon {...iconProps} />;
			case "css":
				return <CssIcon {...iconProps} />;
			case "images":
				return <ImageIcon {...iconProps} />;
			default:
				return <Description {...iconProps} />;
		}
	};

	return (
		<Tooltip
			placement="top"
			title={t(`ASSETS.FILETYPE.${asset.fileType}`, { defaultValue: asset.fileType })}
		>
			{getDocumentIcon(asset.fileType)}
		</Tooltip>
	);
};

export default React.memo(TypeCell);
